export default __webpack_public_path__ + "static/media/G0120.ALS_HOT_Image.1709298180000.e92cf3d1.jpg";